export class Icon {
  constructor (args) {
    const { name, ...props } = args || {}
    this.name = name
    this.props = props || {}
  }
}

export class TextWithIcon {
  constructor (args) {
    if (typeof args === 'string' || args instanceof String) {
      this.text = args
      this.icon = new Icon()
    } else {
      const { text, icon } = args || {}
      this.text = text
      this.icon = new Icon(icon)
    }
  }
}
